import { Box, Theme, Typography } from "@mui/material";
import CustomTable from "../../investorOverview/common/customTable";
import { ContributionAnalysisTableBody } from "./tableBodies";
import { contributionAnalysisTableHeaderData } from "./tableHeaders";

interface TableData {
    id: number;
    issuer: string;
    portfolioWeight: number;
    portfolioReturns: number;
    cumulativeWeight: number;
}

interface IssuerContributionAnalysisProps {
    tableOneData: TableData[]
    tableTwoData: TableData[]
}

export default function IssuerContributionAnalysis({
    tableOneData,
    tableTwoData
}: IssuerContributionAnalysisProps): JSX.Element {
    return (
        <Box
            sx={(theme: Theme) => ({
                marginTop: "15px",
                borderRadius: "25px",
                padding: "35px",
                backgroundColor: theme.palette.common.white,
                boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`
            })}
        >
            <Typography
                variant="h2"
                sx={(theme: Theme) => ({
                    lineHeight: "25px",
                    letterSpacing: "0.01px",
                    color: theme.palette.text.primary
                })}
            >
                Issuer Contribution Analysis
            </Typography>
            <Box
                sx={{
                    marginTop: "35px",
                    display: "flex",
                    columnGap: "56px",
                    rowGap: "30px",
                    flexWrap: "wrap"
                }}
            >
                <Box sx={{ flex: 1 }}>
                    <CustomTable
                        // isLoading
                        tableBody={
                            <ContributionAnalysisTableBody
                                data={tableOneData}
                                type="issuer"
                            />
                        }
                        tableData={tableOneData}
                        tableHeaderData={contributionAnalysisTableHeaderData("issuer")}
                        isPaginationVisible={false}
                        tableDataCount={tableOneData.length}
                        tableBodyLoaderRowCustomStyles={{
                            '& td:first-of-type': {
                                paddingLeft: "0px"
                            },
                        }}
                        tableHeadRowCustomStyles={{
                            '& th:first-of-type': {
                                paddingLeft: "0px"
                            }
                        }}
                        tableBodyCustomStyles={{
                            '& tr:last-child td': {
                                border: 0
                            }
                        }}
                        loadingRowsNum={5}
                    />
                </Box>
                <Box sx={{ flex: 1 }}>
                    <CustomTable
                        // isLoading
                        tableBody={
                            <ContributionAnalysisTableBody
                                data={tableTwoData}
                                type="issuer"
                            />
                        }
                        tableData={tableTwoData}
                        tableHeaderData={contributionAnalysisTableHeaderData("issuer")}
                        isPaginationVisible={false}
                        tableDataCount={tableTwoData.length}
                        tableBodyLoaderRowCustomStyles={{
                            '& td:first-of-type': {
                                paddingLeft: "0px"
                            },
                        }}
                        tableHeadRowCustomStyles={{
                            '& th:first-of-type': {
                                paddingLeft: "0px"
                            }
                        }}
                        tableBodyCustomStyles={{
                            '& tr:last-child td': {
                                border: 0
                            }
                        }}
                        loadingRowsNum={5}
                    />
                </Box>
            </Box>
        </Box>
    )
}